module.exports = __webpack_public_path__ + "f8499d00c4ed54a38e78e95b1bbec4ab.png";


//////////////////
// WEBPACK FOOTER
// ./assets/images/patches/hand/megaphone.png
// module id = 2681
// module chunks = 0